import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#41B883",
      d: "m14.31 4.34-2.31 4-2.31-4H2l10 17.32L22 4.34z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#34495E",
      d: "m14.31 4.34-2.31 4-2.31-4H6l6 10.392L18 4.34z"
    }, null, -1)
  ]))]))
}
export default { render: render }